<template>
    <div ref="listingPage" :class="gridClasses">
        <template v-if="products.length > 0">
            <ProductListingCard
                v-for="(product, index) in products"
                :key="product.id"
                :data="product"
                @click="onListingCardClick(product, index)"
            />
        </template>
        <template v-else>
            {{ t('product.listing.noProducts') }}
        </template>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useNuxtApp } from '#imports'
import type { HblProduct } from '@/utils/types'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    products: HblProduct[],
    pageNumber: number,
    gridClasses: string
}>()

const listingPage = ref<HTMLElement | null>(null)

const { $hblBus } = useNuxtApp()
function onListingCardClick (product: HblProduct, index: number) {
    $hblBus.$emit('clickProductListingCard', { id: 'category', name: 'Category', product, index })
}

const emit = defineEmits<{(event: 'update:url', data: number): void}>()
const observer = ref()
onMounted(() => {

    const options = {
        threshold: 0.05
    }
    observer.value = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                emit('update:url', props.pageNumber)
            }
        })
    }, options)

    observer.value.observe(listingPage.value)
})

onUnmounted(() => {
    if(observer.value != null){
        observer.value?.disconnect()
    }
})
</script>
